import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "reactstrap";

import selectOptions from "shared/prop_types/selectOptions";
import marketingDataCategories from "shared/prop_types/marketingDataCategories";

import { checkboxProps } from "./NotificationCheckbox";
import UserInformation from "./UserInformation";
import UserPermissions from "./UserPermissions";
import UserNotificationSettings from "./UserNotificationSettings";
import UsersSecurityCard from "./UserSecurityCard";
import SendPasswordNotification from "./SendPasswordNotification";

const EditUserFields = ({
  memberID,
  timeZones,
  roles,
  rolePermissionsUrl,
  marketingDataDictionaryUrl,
  userNotificationSettings,
  marketingDataCategories,
  permissions: {
    updateUser,
    updateUserSecurity,
    updateRole,
    manageUsernames,
    manageCredentials,
    manageNotifications,
    updateReportFilters,
    requestPasswordReset,
    manageUserLicenses
  },
  twoFactorAuthRequired,
  sendNumberVerificationRequest,
  currentRole,
  availableUserLicenses
}) => (
  <>
    {updateUser && (
      <FormGroup>
        <UserInformation timeZones={timeZones} manageUsernames={manageUsernames} />
      </FormGroup>
    )}
    {updateUser && manageCredentials && (
      <FormGroup>
        {updateUserSecurity ? (
          <UsersSecurityCard
            twoFactorAuthRequired={twoFactorAuthRequired}
            sendNumberVerificationRequest={sendNumberVerificationRequest}
          />
        ) : (
          requestPasswordReset && (
            <SendPasswordNotification memberID={memberID} />
          )
        )}
      </FormGroup>
    )}
    {updateRole && (
      <FormGroup>
        <UserPermissions
          roles={roles}
          rolePermissionsUrl={rolePermissionsUrl}
          marketingDataDictionaryUrl={marketingDataDictionaryUrl}
          marketingDataCategories={marketingDataCategories}
          updateReportFilters={updateReportFilters}
          manageUserLicenses={manageUserLicenses}
          availableUserLicenses={availableUserLicenses}
          role={currentRole}
        />
      </FormGroup>
    )}
    {manageNotifications && (
      <FormGroup>
        <UserNotificationSettings {...userNotificationSettings} />
      </FormGroup>
    )}
  </>
);

const notificationPreferenceProp = PropTypes.shape(checkboxProps);

EditUserFields.propTypes = {
  memberID: PropTypes.string.isRequired,
  timeZones: selectOptions,
  roles: selectOptions,
  rolePermissionsUrl: PropTypes.string,
  marketingDataDictionaryUrl: PropTypes.string,
  userNotificationSettings: PropTypes.shape({
    generalPreferences: PropTypes.arrayOf(notificationPreferenceProp).isRequired,
    bundledPreferences: PropTypes.arrayOf(notificationPreferenceProp).isRequired,
    nameForAdvertiser: PropTypes.string.isRequired
  }),
  marketingDataCategories: marketingDataCategories,
  permissions: PropTypes.shape({
    updateUser: PropTypes.bool,
    updateUserSecurity: PropTypes.bool,
    updateRole: PropTypes.bool,
    manageUsernames: PropTypes.bool,
    manageCredentials: PropTypes.bool,
    manageNotifications: PropTypes.bool,
    manageUserLicenses: PropTypes.bool
  }),
  twoFactorAuthRequired: PropTypes.bool,
  sendNumberVerificationRequest: PropTypes.func,
  currentRole: PropTypes.string,
  availableUserLicenses: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      roles: selectOptions.isRequired
    })
  )
};

EditUserFields.defaultProps = {
  data: {},
  permissions: {}
};

export default EditUserFields;
